import React from "react";
import "./Button.scss";
import UtilServices from "@services/UtilServices";

export default function Button(props) {
  return (
    <div className={`Button`}>
      <button
        className={`${props.className} theme${props.theme} ${
          props.disabled ? "disabled" : ""
        } ${props.icon ? "icon" : ""}`}
        onClick={props.onClick}
        disabled={props.disabled}
        data-tooltip-id="tooltip-001"
        data-tooltip-content={props.title}
      >
        {UtilServices.stringToJsx(props.icon)}
        <p>{props.nome}</p>
      </button>
    </div>
  );
}

Button.defaultProps = {
  nome: "",
  icon: "",
  className: "",
  onClick: () => null,
  theme: "1",
  disabled: false,
  title: "",
};
